import { render, staticRenderFns } from "./edit-device-service-config.vue?vue&type=template&id=f33a5844&scoped=true"
import script from "./edit-device-service-config.vue?vue&type=script&lang=js"
export * from "./edit-device-service-config.vue?vue&type=script&lang=js"
import style0 from "./edit-device-service-config.vue?vue&type=style&index=0&id=f33a5844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33a5844",
  null
  
)

export default component.exports